import React from "react";
import { useStyles } from "./totp.styles";
import { Box, Grid, Typography } from "@material-ui/core";
import { TextConstants } from "constants/TextConstants";

interface ScannerScreenProps {
  scanner: string | undefined;
}

const ScannerScreen: React.FC<ScannerScreenProps> = ({ scanner }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.scannerContainer}>
      <Typography className="heading" gutterBottom>
        {TextConstants.SET_UP_ACCOUNT}
      </Typography>
      <Typography className="subHeading">{TextConstants.SCAN_INFO}</Typography>
      <Box className="scanner">
        <img src={scanner ? scanner : ""} alt="QR-Code" />
      </Box>
    </Grid>
  );
};

export default ScannerScreen;
